module.exports = ".full-width-input {\n  width: 100%; }\n\n::ng-deep .mat-form-field-label-wrapper {\n  top: -1.4em !important; }\n"